import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";

const Footer = () => {
  return (
    <footer
      className="border-t mt-24"
      style={{
        borderColor: "rgba(201, 192, 171, 0.55)",
        backgroundColor: "var(--mc-bg-2)",
      }}
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <h3
            className="font-serif-display text-2xl mb-3"
            style={{ color: "var(--mc-ink)" }}
          >
            Maxfield Counselling
          </h3>
          <p
            className="text-sm leading-relaxed max-w-xs"
            style={{ color: "var(--mc-ink-2)" }}
          >
            Counselling &amp; therapy for emotional wellbeing and meaningful
            personal growth.
          </p>
        </div>

        <div>
          <p
            className="text-sm md:text-base tracking-eyebrow uppercase mb-4"
            style={{ color: "var(--mc-muted)" }}
          >
            Explore
          </p>
          <ul className="space-y-2 text-sm" style={{ color: "var(--mc-ink-2)" }}>
            <li>
              <Link to="/" data-testid="footer-home">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" data-testid="footer-about">
                About
              </Link>
            </li>
            <li>
              <Link to="/approach" data-testid="footer-approach">
                Therapeutic Approach
              </Link>
            </li>
            <li>
              <Link to="/contact" data-testid="footer-contact">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p
            className="text-sm md:text-base tracking-eyebrow uppercase mb-4"
            style={{ color: "var(--mc-muted)" }}
          >
            Get in touch
          </p>
          <ul className="space-y-3 text-sm" style={{ color: "var(--mc-ink-2)" }}>
            <li className="flex items-center gap-3">
              <Phone size={14} />
              <a href="tel:+61438350547" data-testid="footer-phone">
                0438 350 547
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={14} />
              <a
                href="mailto:cmaxfield3@hotmail.com"
                data-testid="footer-email"
                className="break-all"
              >
                cmaxfield3@hotmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="border-t"
        style={{ borderColor: "rgba(201, 192, 171, 0.55)" }}
      >
        <div
          className="max-w-6xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs"
          style={{ color: "var(--mc-muted)" }}
        >
          <p data-testid="footer-copy">
            © {new Date().getFullYear()} Carl Maxfield. All rights reserved.
          </p>
          <p data-testid="footer-abn">ABN: 45 429 419 329</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
